// web环境http请求
/*
 * @Author: wyh
 * @Date: 2020-04-20 21:15:20
 * @Last Modified by: wyh
 * @Last Modified time: 2020-04-23 11:02:05
 */

import axios from 'axios';
import qs from 'qs';
import { Toast } from 'vant';
import { baseURL, tenantId } from './commonParams';
import { ABNORMAL_MSG } from '@/const/prompt';
import getApiHost from './getApiHost.js';
const apiHost = getApiHost();
axios.defaults.withCredentials = true; //让ajax携带cookie

// 创建axios实例
const service = axios.create({
  baseURL: baseURL, // process.env.BASE_API, // api 的 base_url
  timeout: 15000, // 请求超时时间
  withCredentials: true
});
// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers['Content-Type'] = config['Content-Type'] || 'application/x-www-form-urlencoded';
    // todo 登录相关接口
    if (!config.data) config.data = {};
    config.method = config.method || 'post';
    config.data.tenantId = config.data.tenantId || tenantId;
    config.data.channel = config.data.channel || 'h5';
    config.data.domainType = 200;
    if(config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  (error) => {
    console.warn('request error', error);
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    const netWork = window.navigator.onLine;
    const interUrl = response.config.url
    console.log('axios response:', response);
    if (!res) {
      console.warn('response error:', response);
      if(interUrl && interUrl.indexOf('log/unicorn/event') !== -1) {
        return Promise.reject(res)
      }
      Toast(`${!netWork ? ABNORMAL_MSG.NETWORK_OFFLINE : ABNORMAL_MSG.SERVER_ERROR}`)
      return Promise.reject(res);
    }

    return Promise.resolve(res);
  },
  (error) => {
    const netWork = window.navigator.onLine;
    console.warn('response error2:', error);
    Toast(`${!netWork ? ABNORMAL_MSG.NETWORK_OFFLINE : ABNORMAL_MSG.SERVER_ERROR}`)
    return Promise.reject(error);
  }
);
// 封装post请求
export function post(url, data = {}, headers) {
  const realUrl = apiHost + url;
  return new Promise((resolve, reject) => {
    service.post(realUrl, data, headers).then(
      (response) => {
        // resolve(response.data);
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export default service;
